import * as yup from 'yup';

export default yup.object().shape({
    password: yup.string().required().min(6),
});